"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const cssCalcBetweenViewport = (min, max, type = 'px', minViewport = 320, maxViewport = 2000) => `
    calc(${min}${type} + (${max} - ${min}) * ((100vw - ${minViewport}px) / (${maxViewport} - ${minViewport})))
`;
var _default = exports.default = cssCalcBetweenViewport;